import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CancelIcon from '@mui/icons-material/Cancel';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

const StatusBadge = ({ status, size = 'normal' }) => {
  const getStatusConfig = (status, size) => {
    switch (status) {
      case 'Renewed':
        return {
          backgroundColor: '#E6F9EB',
          textColor: '#137333',
          icon: <CheckCircleIcon style={{ color: '#137333', fontSize: size === 'small' ? 12 : 16 }} />,
          text: 'Renewed'
        };
      case 'Active':
        return {
          backgroundColor: '#E0EBFF',
          textColor: '#0063F7',
          icon: <RadioButtonCheckedIcon style={{ color: '#0063F7', fontSize: size === 'small' ? 12 : 16 }} />,
          text: 'Active'
        };
      case 'Expired':
        return {
          backgroundColor: '#FFADA8',
          textColor: '#B00020',
          icon: <CancelIcon style={{ color: '#B00020', fontSize: size === 'small' ? 12 : 16 }} />,
          text: 'Expired'
        };
      case 'Pending':
        return {
          backgroundColor: '#FFE4AD',
          textColor: '#B45309',
          icon: <ScheduleIcon style={{ color: '#B45309', fontSize: size === 'small' ? 12 : 16 }} />,
          text: 'Pending'
        };
      case 'New Lead':
        return {
          backgroundColor: '#FFE4AD',
          textColor: '#B45309',
          icon: <LocalOfferIcon style={{ color: '#B45309', fontSize: size === 'small' ? 12 : 16 }} />,
          text: 'New Lead'
        };
      default:
        return {
          backgroundColor: '#E0EBFF',
          textColor: '#0063F7',
          icon: <RadioButtonCheckedIcon style={{ color: '#0063F7', fontSize: size === 'small' ? 12 : 16 }} />,
          text: status || 'Active'
        };
    }
  };

  const config = getStatusConfig(status, size);

  const dimensions = size === 'small' ? {
    height: '20px',
    fontSize: '10px',
    lineHeight: '14px',
    padding: '2px 6px',
    width: '95px'
  } : {
    height: '28px',
    fontSize: '14px',
    lineHeight: '20px',
    padding: '4px 10px',
    width: '110px'
  };

  return (
    <div
      style={{
        height: dimensions.height,
        width: dimensions.width,
        maxWidth: dimensions.width,
        overflow: 'visible',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: size === 'small' ? '2px' : '4px',
        borderRadius: size === 'small' ? '8px' : '12px',
        padding: dimensions.padding,
        backgroundColor: config.backgroundColor,
        border: 'none',
        outline: 'none',
        boxSizing: 'border-box',
        position: 'relative',
        zIndex: 1,
      }}
      className="status-badge"
    >
      {config.icon}
      <span
        style={{
          color: config.textColor,
          fontFamily: 'Roboto',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSize: dimensions.fontSize,
          lineHeight: dimensions.lineHeight,
          letterSpacing: '0.01em',
          margin: 0,
          padding: 0,
          textAlign: 'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {config.text}
      </span>
    </div>
  );
};

export default StatusBadge;
